<div class="row page-header" [hidden]="embedded">
    <div class="col-12">
        <h1>Proposal Bids <small>View and manage proposal bid information</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Proposal Bids'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        style="height: 300px"
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        (selectionChanged)="filterDetailItems()"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="'*'" [minWidth]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Owner'"
                            [binding]="'ownerId'"
                            [width]="'*'"
                            [dataMap]="ownersMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Type'"
                            [binding]="'bidTypeId'"
                            [width]="'*'"
                            [dataMap]="jobTypeMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'County'"
                            [binding]="'countyId'"
                            [width]="'*'"
                            [dataMap]="countiesMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="detailGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="detailGrid"
                            [canEdit]="grid.selectedItem && canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="detailSearch" [(ngModel)]="detailGrid.filter"></action-toolbar-search>
                        <grid-export [grid]="detailGridRef" [name]="'Proposal Bid Details'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="detailGrid"
                        #detailGridRef
                        appAutoSize
                        (initialized)="detailGrid.initialize(detailGridRef)"
                        (destroy)="detailGrid.destroy()"
                        [itemsSource]="detailGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Competitor'"
                            [binding]="'competitorId'"
                            [width]="180"
                            [dataMap]="competitorsMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Design Fee'"
                            [binding]="'designFee'"
                            [width]="120"
                            [format]="'n2'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'CM Fee'" [binding]="'cmFee'" [width]="120" [format]="'n2'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'CM Monthly Fee'"
                            [binding]="'cmMonthlyFee'"
                            [width]="140"
                            [format]="'n2'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor OHP Fee'"
                            [binding]="'contractorOhpFee'"
                            [width]="160"
                            [format]="'n2'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor Bonds/Ins'"
                            [binding]="'contractorBondsIns'"
                            [width]="170"
                            [format]="'n2'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor CO Markup'"
                            [binding]="'contractorCoMarkup'"
                            [width]="170"
                            [format]="'n2'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'City Budget'"
                            [binding]="'cityBudget'"
                            [width]="120"
                            [format]="'n2'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor Start'"
                            [binding]="'contractorStartDate'"
                            [width]="140"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor Days'"
                            [binding]="'contractorNumDays'"
                            [width]="130"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor Projects'"
                            [binding]="'contractorNumProjects'"
                            [width]="150"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'PM Projects'" [binding]="'pmNumProjects'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Contractor PM'" [binding]="'contractorPm'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Contractor Super'"
                            [binding]="'contractorSuper'"
                            [width]="150"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Reference 1'" [binding]="'contractorRef1'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Reference 2'" [binding]="'contractorRef2'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Reference 3'"
                            [binding]="'contractorRef3'"
                            [width]="'*'"
                            [minWidth]="150"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
